import { apiCall } from "../service/api-service";

// Cross-module chatbot. Separate from the per-module endpoints: this one
// reaches every module's tools through AiController.
export const askCrmChatApi = async (payload) => {
  return apiCall("POST", "web/ai_chat", payload);
};

export const getCrmAiProvidersApi = async () => {
  return apiCall("GET", "web/ai_providers");
};
